import React, { useEffect } from 'react';
import { Form, Input, Modal, Select } from 'antd';

const PackageRolesForm = ({ visible, onCreate, onCancel, record }) => {
  const [form] = Form.useForm();


  useEffect(() => {
    if (record) {
      console.log("record :", record);
      
      form.setFieldsValue({
        role: record.role,
      });
    }
    else {
      // Reset form when record is null (for adding new state)
      form.resetFields();
    }
  }, [record, form]);

  const handleChange = (value) => {
    console.log(`selected ${value}`);
  };

  return (
    <Modal
      visible={visible}
      title={record ? "Update Package Roles" : "Add Package Roles"}
      okText="Submit"
      cancelText="Cancel"
      // onCancel={onCancel}
      onCancel={() => {
        form.resetFields(); // Reset form fields when modal is closed
        onCancel(); // Call the onCancel handler
      }}
      onOk={() => {
        form
          .validateFields()
          .then(values => {
            onCreate(values);
            form.resetFields();
          })
          .catch(info => {
            console.log('Validate Failed:', info);
          });
      }}
      width={800}
    >
      <Form
        form={form}
        layout="vertical"
        name="model_form"
        initialValues={record}
      >
       
        <Form.Item
          name="role"
          label="Role"
          rules={[{ required: true, message: 'Please enter the Role!' }]}
        >
          <Input />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default PackageRolesForm;